<template>
  <component
    :is="partner.link ? DynamicLink : 'div'"
    :link="partner.link"
    :title="partner.name"
    :class="['flex items-center max-h-12.5', { 'hover:scale-95 transition-[scale]': partner.link }]"
  >
    <ResponsiveImage :media="partner.logo" class="w-full max-h-full object-contain" />
  </component>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { ResponsiveImage } from "@/components/helpers";
import { DynamicLink } from "@/components/small";

export default {
  name: "PartnerCard",
  components: { ResponsiveImage },
  props: {
    partner: {
      type: Object as PropType<Partner>,
      required: true,
    },
  },
  setup() {
    return {
      DynamicLink,
    };
  },
};
</script>
